import "./styles.scss";

import { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { postAffiliatePayment } from "../../../store/middleware";
import zellePNG from "../../../assets/images/affiliates/zelle.png";
import payPalPNG from "../../../assets/images/affiliates/payPal.png";
// import venmoPNG from "../../../assets/images/affiliates/venmo.png";
import payonnerPNG from "../../../assets/images/affiliates/payonner.png";

function ModalPaymentInformation({ showModal, setShowModal }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const [provider, setProvider] = useState("");
  const [providerUser, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  const validateForms = () => {
    if (provider === "") {
      alert("Infome o método de pagamento");
      return false;
    } else if (providerUser === "") {
      alert("Infome o usuário da conta");
      return false;
    } else return true;
  };

  const handleSave = async () => {
    if (validateForms()) {
      const body = {
        provider,
        providerUser,
        userId: affiliateInfo?.userId,
        affiliateId: affiliateInfo?.id,
      };

      await dispatch(postAffiliatePayment(body)).then((res) => res.success && setSuccess(true));
    }
  };

  return (
    <Dialog
      open={showModal}
      className="modalPrivilege"
      classes={"modalPaymentInformation"}
      onClose={() => setShowModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="containerPaymentInformation">
        <h3 className="title">{t("PAYMENT_METHOD")}</h3>

        {!success ? (
          <form className="contentPaymentInformation">
            <div className="wrapperIcons">
              <div>
                <label htmlFor="gender">{t("PAYMENT_METHOD_LABEL")}</label>

                <div className="icons">
                  <div className={provider === "payoneer" && "active"} onClick={() => setProvider("payoneer")}>
                    <img src={payonnerPNG} />
                  </div>
                  <div className={provider === "paypal" && "active"} onClick={() => setProvider("paypal")}>
                    <img src={payPalPNG} />
                  </div>
                  <div className={provider === "zelle" && "active"} onClick={() => setProvider("zelle")}>
                    <img src={zellePNG} />
                  </div>
                  {/* {affiliateInfo?.user?.countryId === 212 && (
                    <div className={provider === "venmo" && "active"} onClick={() => setProvider("venmo")}>
                      <img src={venmoPNG} />
                    </div>
                  )} */}
                </div>
              </div>
            </div>

            <div className="wrapperEmail">
              <label htmlFor="gender">
                {t("EMAIL")} {provider === "zelle" && `/ ${t("TELEPHONE")}`}
              </label>
              <input type="text" value={providerUser} onChange={({ target }) => setEmail(target.value)} />
            </div>

            <p className="alertMessage">
              {t("MODAL_PAYAMENT_ALERT01")}
              <strong>{t("MODAL_PAYAMENT_ALERT02")}</strong> {t("MODAL_PAYAMENT_ALERT03")}
            </p>
          </form>
        ) : (
          <h4>{t("SUCCESS_MESSAGE_PATMENT_METHOD")}</h4>
        )}

        <div className="footer">
          {!success ? (
            <>
              <button className="buttonModalBack" onClick={() => setShowModal(false)}>
                {t("BACK")}
              </button>
              <button className="buttonModalSave" onClick={handleSave}>
                {t("SAVE")}
              </button>
            </>
          ) : (
            <button className="buttonModalSave" onClick={() => setShowModal(false)}>
              {t("BTN_CLOSE")}
            </button>
          )}
        </div>
      </div>
    </Dialog>
  );
}

export default ModalPaymentInformation;
